import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { PostJSON } from "../lib/fetchers.js";

import { UserAvatar } from "./user-avatar.js";

// Register required webcomponents
UserAvatar.Register();

/**
 * Array of user avatars
 * Relies on window.CurrentTrain
 */
export class FacePile extends UnshadowedElement {
    static elementName() { return "face-pile" }

    static properties = {
        maxAvatars: { type: Number },

        participants: { state: true, type: Array },
        totalParticipants: { state: true, type: Number },
    };

    constructor() {
        super();
        // Defaults
        this.maxAvatars = 6;
    }

    async connectedCallback() {
        super.connectedCallback();
        // Load facepile from backend
        try {
            const result = await PostJSON("/trains/" + window.CurrentTrain.Id + "/facepile", { max: this.maxAvatars });
            this.participants = result.participants;
            this.totalParticipants = result.totalParticipants;
        } catch {
            // On failure, we just won't show
        }
    }

    render() {
        if (this.participants && this.participants.length) {
            const nodes = [];
            for (const participant of this.participants) {
                nodes.push(html`<li><user-avatar avatar=${participant.Avatar} initials=${participant.Initials}></user-avatar></li>`);
            }
            if (this.totalParticipants > this.maxAvatars) {
                nodes.push(html`<li class="avatar-stack__total">+${this.totalParticipants - this.maxAvatars}</li>`);
            }
            return html`
                <ul class="avatar-stack">
                    ${nodes}
                </ul>
            `;
        } else {
            return null;
        }
    }
}
